import LegalPage from "@/components/site/LegalPage";
import { BRAND } from "@/data/content";

const SECTIONS = [
  {
    heading: "Agreement to these terms",
    paras: [
      `These Terms of Use govern your access to and use of blezzings.co, operated by ${BRAND.fullName} ("BLEZZINGS", "we", "us"). By using this website, you agree to these terms. If you do not agree, please do not use the website.`,
    ],
  },
  {
    heading: "About this website",
    paras: [
      `This website presents the services, perspectives and activities of ${BRAND.fullName}, a Sales & Marketing transformation consultancy based in ${BRAND.contact.location}, India. Content on this site is provided for general information only.`,
    ],
  },
  {
    heading: "Intellectual property",
    paras: [
      "All content on this website — including text, design, graphics, logos, frameworks and publications — is the property of BLEZZINGS or its licensors and is protected by applicable intellectual property laws. You may view and share links to our content for personal, non-commercial purposes. You may not reproduce, republish or commercially exploit any content without our prior written consent.",
    ],
  },
  {
    heading: "No professional advice",
    paras: [
      "The content on this website, including our insights and articles, is general in nature and does not constitute professional, financial, legal or investment advice. Any engagement with BLEZZINGS is governed solely by a separate written agreement between you and us.",
    ],
  },
  {
    heading: "Leadership impact and examples",
    paras: [
      "Figures and outcomes shown on this website under \u201cSelected Leadership Impact\u201d represent the prior operating and consulting leadership experience of our leadership team. They do not represent engagements, results or clients of BLEZZINGS Growth Partners, and they should not be read as a promise of specific outcomes for any future engagement.",
    ],
  },
  {
    heading: "Enquiries and applications",
    paras: [
      "When you submit an enquiry, request a consultation or apply for a role, you agree that the information you provide is accurate and that we may use it to respond to you, as described in our Privacy Policy. Submitting a form does not create a consulting, employment or any other contractual relationship.",
    ],
  },
  {
    heading: "Acceptable use",
    paras: ["You agree not to:"],
    bullets: [
      "Use the website in any way that is unlawful, misleading or harmful.",
      "Attempt to gain unauthorised access to the website, its servers or its data.",
      "Introduce malicious code or interfere with the website's operation.",
      "Scrape or harvest content or personal information from the website without consent.",
    ],
  },
  {
    heading: "Third-party links and services",
    paras: [
      "This website may contain links to third-party websites and services. We do not control and are not responsible for their content, availability or practices.",
    ],
  },
  {
    heading: "Disclaimers and limitation of liability",
    paras: [
      "This website is provided \u201cas is\u201d and \u201cas available\u201d, without warranties of any kind, express or implied. To the fullest extent permitted by law, BLEZZINGS shall not be liable for any indirect, incidental or consequential loss, or any loss of profit, revenue or data, arising from your use of — or inability to use — this website.",
    ],
  },
  {
    heading: "Governing law and jurisdiction",
    paras: [
      "These terms are governed by the laws of India. Any dispute arising out of or relating to the use of this website shall be subject to the exclusive jurisdiction of the courts at Bengaluru, Karnataka.",
    ],
  },
  {
    heading: "Changes to these terms",
    paras: [
      "We may update these Terms of Use from time to time. The latest version will always be published on this page with its revision date. Continued use of the website after changes take effect constitutes acceptance of the revised terms.",
    ],
  },
  {
    heading: "Contact us",
    paras: [
      `${BRAND.fullName}, ${BRAND.contact.location}, India.`,
      `Email: ${BRAND.contact.email} · Phone: ${BRAND.contact.phone}`,
    ],
  },
];

export default function TermsOfUsePage() {
  return (
    <LegalPage
      testid="terms-of-use-page"
      badge="Legal"
      title="Terms of Use"
      intro="The terms that govern your use of the BLEZZINGS website and its content."
      updated="July 2026"
      sections={SECTIONS}
      meta={{
        title: "Terms of Use | BLEZZINGS Growth Partners",
        description:
          "Terms of Use for blezzings.co — intellectual property, acceptable use, disclaimers, limitation of liability and governing law for the BLEZZINGS website.",
        canonical: "https://blezzings.co/terms-of-use",
        breadcrumbs: [
          { name: "Home", url: "https://blezzings.co/" },
          { name: "Terms of Use", url: "https://blezzings.co/terms-of-use" },
        ],
      }}
    />
  );
}
